import {Map as BaseMap, ControlPosition, MapControl} from '@vis.gl/react-google-maps';
import {useEffect, useRef} from 'react';

import {UndoRedoControl} from '@/components/map/components/undoRedoControl';
import {useDrawingManager} from '@/components/map/hooks/useDrawingManager';

import {OverlayJSON} from './types';

interface PROPS {
  // Initial overlays to be displayed on the map
  initialOverlays?: OverlayJSON[];
  // Callback function to handle changes in the overlays
  onChangeOverlays: (overlays: OverlayJSON[]) => void;
}

/**
 * Map component for displaying the map and handling drawing functionality
 * @returns The Map component
 */
export const Map = ({initialOverlays, onChangeOverlays}: PROPS) => {
  const {drawingManager, overlaysJSON, createOverlayFromJSON} = useDrawingManager(initialOverlays);
  const prevOverlaysRef = useRef<OverlayJSON[] | null>(null);

  useEffect(() => {
    if (overlaysJSON && JSON.stringify(prevOverlaysRef.current) !== JSON.stringify(overlaysJSON)) {
      prevOverlaysRef.current = overlaysJSON;
      onChangeOverlays(overlaysJSON);
    }
  }, [overlaysJSON, onChangeOverlays]);

  useEffect(() => {
    return () => {
      prevOverlaysRef.current = null;
    };
  }, []);

  return (
    <div className="h-[300px] w-full !rounded-md">
      <BaseMap
        defaultZoom={12}
        defaultCenter={{lat: 34.0522, lng: -118.2437}}
        gestureHandling={'greedy'}
        mapTypeControl={false}
        streetViewControl={false}
      />
      <MapControl position={ControlPosition.TOP_CENTER}>
        <UndoRedoControl
          drawingManager={drawingManager}
          initialOverlays={initialOverlays}
          createOverlayFromJSON={createOverlayFromJSON}
        />
      </MapControl>
    </div>
  );
};
